import newsController from "../../../controllers/newsController/controller";
import Swal from 'sweetalert2';
import { EventBus } from '@/eventBus';
import config from "../../../../config";

export default {
    name: 'SimpleTable',
    data() {
        return {
            editorOption: {
                theme: 'snow', // wajib untuk tampilan modern
                modules: {
                    toolbar: [
                        ['bold', 'italic', 'underline', 'strike'], // teks style
                        [{ 'header': 1 }, { 'header': 2 }],        // heading
                        [{ 'list': 'ordered'}, { 'list': 'bullet' }], // list
                        [{ 'indent': '-1'}, { 'indent': '+1' }],   // indentasi
                        [{ 'align': [] }],                         // alignment
                        [{ 'color': [] }, { 'background': [] }],   // warna teks
                        ['link', 'image', 'code'],                      // insert link, gambar, dan kode
                        ['clean']                                  // hapus format
                    ]
                }
            },
            company: '',
            newsList: [],
            currentPage: 1,
            pageSize: 10,
            totalNews: 0,
            sizes: [1,5,10,20],
            apiUrl: config.AWS_URL + 'gambar/news/',
            gambarName: 'Pilih Gambar',
            gambarUrl: '',
            searchQuery: '',
            news: {
                id: '',
                title: '',
                content: '',
                news: '',
                language: '',
                created_by: '',
                created_by_name: '',
                status: ''
            },
            selectedNews: {
                updated_by: '',
                updated_by_name: '',
            },
            content: '',
            contentEdit: ''
        }
    },
    computed: {
        filteredNews() {
            return this.newsList.filter(news => news.title.toLowerCase().includes(this.searchQuery.toLowerCase()));
        },
        pages(){
            return Math.ceil(this.totalNews / this.pageSize);
        },
        displayedPages() {
            const range = 1;
            let start = Math.max(this.currentPage - range, 1);
            let end = Math.min(this.currentPage + range, this.pages);
    
            // Jika kurang dari 3 halaman, sesuaikan
            if (end - start < 2) {
            if (start === 1) {
                end = Math.min(3, this.pages);
            } else if (end === this.pages) {
                start = Math.max(this.pages - 2, 1);
            }
            }
    
            const pages = [];
            for (let i = start; i <= end; i++) {
            pages.push(i);
            }
            return pages;
        },
        showStartEllipsis() {
            return this.displayedPages[0] > 1;
        },
        showEndEllipsis() {
            return this.displayedPages[this.displayedPages.length - 1] < this.pages;
        },
    },
    methods: {
        onEditorInput(value) {
            this.content = value
        },
        EditorInputChange(value) {
            this.contentEdit = value
        },
        user(){
            const user = localStorage.getItem('user');
            const id = JSON.parse(user).mst_employee_id;
            this.news.created_by = id;
            this.selectedNews.updated_by = id;
            const name = JSON.parse(user).mst_employee_name;
            this.news.created_by_name = name;
            this.selectedNews.updated_by_name = name;
        },
        showModal(type, id) {
            this.user();
            const news = this.newsList.find(news => news.id === id);
            if (news) {
                this.news = news;
                this.contentEdit = news.content
                
                const modal = document.getElementById(type === 'edit' ? 'editNews' : 'detailNews');
                
                modal.style.display = 'block';
                requestAnimationFrame(() => {
                modal.classList.add('show');
                });
                
                document.body.classList.add('modal-open');
                
                const backdrop = document.createElement('div');
                backdrop.classList.add('modal-backdrop', 'fade');
                document.body.appendChild(backdrop);
                
                requestAnimationFrame(() => {
                backdrop.classList.add('show');
                });
            }
        },
        closeModal() {
            const modalIds = ['tambahNews', 'editNews', 'detailNews'];
            modalIds.forEach(id => {
            const modal = document.getElementById(id);
            if (modal && modal.classList.contains('show')) {
                modal.classList.remove('show');
                setTimeout(() => {
                modal.style.display = 'none';
                }, 300);
            }
            });
        
            // Hapus backdrop
            const backdrops = document.querySelectorAll('.modal-backdrop');
            backdrops.forEach(backdrop => {
            backdrop.classList.remove('show');
            setTimeout(() => {
                if (backdrop.parentNode) {
                backdrop.parentNode.removeChild(backdrop);
                }
            }, 300);
            });
        
            // Hapus kelas atau atribut yang mengunci scroll pada body
            const body = document.body;
            body.classList.remove('modal-open');
            body.style.overflow = ''; // Menghapus properti overflow jika ada
            this.getNews();
            this.resetForm();
            this.user();
        },    
        resetForm() {
            this.gambarName = 'Pilih Gambar';
            this.gambarUrl = '';
            this.news.title = '';
            this.news.content = '';
            this.news.language = '';
            this.news.news = '';
            this.news.status = ''
        },
        changePage(page) {
            if (page > 0 && page <= this.pages) {
                this.currentPage = page;
                this.getNews();
            }
        },
        async handleFileUpload(event) {
            try{
                const file = event.target.files[0];
                if (file) {
                    this.gambarName = file.name;
                    const reader = new FileReader();
                    reader.onload = (e) => {
                        this.gambarUrl = e.target.result;
                    };
                    reader.readAsDataURL(file);
                }
                if (!file) {
                    alert('Silahkan pilih file');
                    return;
                }

                // Validasi tipe file (opsional)
                const allowedTypes = ['image/jpeg', 'image/jpg', 'image/png'];
                if (!allowedTypes.includes(file.type)) {
                    alert('Hanya file gambar yang diperbolehkan');
                    return;
                }
                const allowedSize = 1 * 1024 * 1024; // 1 MB
                if (file.size > allowedSize) {
                    Swal.fire({
                        icon: 'error',
                        title: 'Oops..',
                        text: `Ukuran file terlalu besar, maksimal ${allowedSize / 1024 / 1024} MB`,
                        timer: 1500
                    })
                    this.resetForm();
                    return;
                }

                this.news.news = file;
            } catch (error) {
                alert('Gagal mengunggah file');
            }
        },
        async getNews() {
            try{
                const company = this.company;
                const query = this.searchQuery.trim() === '' ? null : this.searchQuery;
                const response = await newsController.getNews(query, this.currentPage, this.pageSize, company);
                // test
                this.newsList = response.data;
                this.totalAllNews();
            } catch (error) {
                console.error('Error fetching news:', error);
            }
        },
        async totalAllNews(){
            try{
                const company = this.company;
                const query = this.searchQuery.trim() === '' ? null : this.searchQuery;
                const response = await newsController.totalAllNews(query, company);
                this.totalNews = response.data;
            } catch (error) {
                console.error('Error fetching news:', error);
            }
        },
        async addNews() {
            try {
                Swal.fire({
                    title: 'Loading...',
                    text: 'Please wait while the client is being deleted',
                    allowOutsideClick: false,
                    showConfirmButton: false,
                    willOpen: () => {
                        Swal.showLoading();
                    }
                });
                const formData = new FormData();
                formData.append('title', this.news.title);
                formData.append('content', this.content);
                formData.append('news', this.news.news);
                formData.append('language', this.news.language);
                formData.append('company', this.company);
                formData.append('created_by', this.news.created_by);
                formData.append('is_active', this.news.status);
                formData.append('created_by_name', this.news.created_by_name);
                if (formData.get('title') === '' || formData.get('content') === '' || formData.get('news') === '' || formData.get('language') === '' || formData.get('company') === '' || formData.get('created_by') === '' || formData.get('created_by_name') === '') {
                    Swal.fire({
                        icon: 'error',
                        title: 'Oops...',
                        text: 'Semua field harus diisi',
                        timer: 1500
                    });
                    return;
                }
                const response = await newsController.addNews(formData, {
                    headers: {
                        'Content-Type' : 'multipart/form-data'
                    }
                });
                if (response.status === 200) {
                    Swal.fire({
                        icon: 'success',
                        title: 'News berhasil ditambahkan',
                        showConfirmButton: false,
                        timer: 1500
                    })
                    this.closeModal();
                    this.getNews();
                } else {
                    Swal.fire({
                        icon: 'error',
                        title: 'Gagal menambahkan Berita',
                        timer: 1500
                    });
                }
            } catch (error) {
                Swal.fire({
                    icon: 'error',
                    title: 'Gagal menambahkan news',
                    timer: 1500
                });
            }
        },
        async updateNews() {
            try {
                const id = this.news.id;
                const title = this.news.title;
                const content = this.contentEdit;
                const news = this.news.news;
                const status = this.news.status;
                const updated_by = this.selectedNews.updated_by;
                const updated_by_name = this.selectedNews.updated_by_name;
                if (!id || !title || !content || !news || !status || !updated_by || !updated_by_name) {
                    Swal.fire({
                        icon: 'error',
                        title: 'Gagal memperbarui data',
                        text: 'Isi semua field!!',
                        timer: 1500
                    })
                    return;
                }
                const update_on = new Date().toISOString().slice(0, 19).replace('T', ' ');
                const update = {
                    id: id,
                    title: title,
                    content: content,
                    news: news,
                    is_active: status,
                    updated_by: updated_by,
                    updated_by_name: updated_by_name,
                    updated_on: update_on
                }
                const response = await newsController.updateNews(update);
                if (response && response.status === 200) {
                    Swal.fire({
                        icon: 'success',
                        title: 'News berhasil diperbarui',
                        showConfirmButton: false,
                        timer: 1500
                    });
                    this.closeModal();
                    this.getNews();
                } else {
                    Swal.fire({
                        icon: 'error',
                        title: 'Gagal memperbarui news',
                        timer: 1500
                    });
                }
            } catch (error) {
                Swal.fire({
                    icon: 'error',
                    title: 'Gagal memperbarui news',
                    timer: 1500
                });
            }
        },
        async deleteNews(id, news) {
            const confirmed = await Swal.fire({
                title: 'Are you sure?',
                text: 'You won\'t be able to revert this!',
                icon: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: 'Yes, delete it!'
            }).then((result) => {
                if (result.isConfirmed) {
                    return true;
                }
                return false;
            });
            if (confirmed) {
                try {
                    Swal.fire({
                        title: 'Loading...',
                        text: 'Please wait while the client is being deleted',
                        allowOutsideClick: false,
                        showConfirmButton: false,
                        willOpen: () => {
                            Swal.showLoading();
                        }
                    });
                    const response = await newsController.deleteNews(id, news);
                    if (response.status === 200) {
                        Swal.fire({
                            icon: 'success',
                            title: 'Data berhasil dihapus',
                            showConfirmButton: false,
                            timer: 1500
                        })
                    } else {
                        Swal.fire({
                            icon: 'error',
                            title: 'Data gagal dihapus',
                            showConfirmButton: false,
                            timer: 1500
                        })
                    }
                    this.getNews();
                } catch (error) {
                    Swal.fire({
                        icon: 'error',
                        title: 'Data gagal dihapus',
                        showConfirmButton: false,
                        timer: 1500
                    })
                }
            }
        },
        onCompanyChange(newCompany) {
            this.company = newCompany;
        }   
    },
    mounted(){
        this.user();
        this.company = localStorage.getItem('company');
        EventBus.$on("companyChanged", this.onCompanyChange);
    },
    watch: {
        searchQuery:{
            handler: 'getNews',
        },
        company : {
            handler: 'getNews'
        }
    },
}